// List of Organization slugs that require private access (user/pass) when visiting the DAO page
export const ORGANIZATION_PRIVATE_ACCESS_SLUGS = [
  "zksync-nation",
  "zk-nation",
  "testnet-zksync",
  "testnet-zksync-staging",
  "wormhole-private",
  "zksync-private",
  "codename-testnet",
  "codename-mainnet",
  "codename-testnet-claim",
  "codename-g",
  "testnet-agld",
  "testnet-agld-v2",
  "testnet-agld-v3",
  "testnet-agld-v4",
  "eigenlayer",
  "mother-dao",
  "gaianet",
  "multigov-private",
  "glif-fake-mainnet",
  "anime-dao",
  "anime-dao-testnet",
]
